import React from 'react';
import AffiliateLink from './AffiliateLink';

const PaymentCards = ({ className = '' }) => {
  return (
    <AffiliateLink className={`inline-flex items-center justify-center gap-2 ${className}`}>
      <div className="flex items-center gap-2 bg-white p-2 rounded">
        {/* Visa */}
        <div className="bg-[#1a1f71] text-white text-xs font-bold px-3 py-1.5 rounded italic">
          VISA
        </div>
        {/* Mastercard */}
        <div className="bg-gradient-to-r from-[#eb001b] to-[#f79e1b] text-white text-xs font-bold px-2 py-1.5 rounded">
          <span className="text-[#eb001b]">●</span><span className="text-[#f79e1b]">●</span>
        </div>
        {/* Discover */}
        <div className="bg-[#ff6000] text-white text-xs font-bold px-2 py-1.5 rounded">
          DISCOVER
        </div>
        {/* Amex */}
        <div className="bg-[#006fcf] text-white text-xs font-bold px-2 py-1.5 rounded">
          AMEX
        </div>
      </div>
    </AffiliateLink>
  );
};

export default PaymentCards;